import { Box, Typography, IconButton, Stack, Link } from "@mui/material";
import { LinkedIn } from "@mui/icons-material";
import TikTokIcon from "@mui/icons-material/MusicNote";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";

const ContactInquiry = () => {
  return (
    <Box sx={{ padding: 3, bgcolor: "#f2cdad" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          mb: { xs: 1, md: 4 },
        }}
      >
        <Box>
          <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
            <LocationOnOutlinedIcon
              sx={{ fontSize: "1rem", color: "#000", mr: 2 }}
            />
            <Typography sx={{ color: "#000", maxWidth: "90%" }}>
              Port Harcourt, Nigeria
            </Typography>
          </Box>
          <Box sx={{ mt: 1, display: "flex", alignItems: "center" }}>
            <EmailOutlinedIcon
              sx={{ fontSize: "1rem", color: "#000", mr: 2 }}
            />
            <Typography sx={{ color: "#000", maxWidth: "90%" }}>
              info@tuberway.com
            </Typography>
          </Box>
          <Box sx={{ mt: 1, display: "flex", alignItems: "center" }}>
            <PhoneOutlinedIcon
              sx={{ fontSize: "1rem", color: "#000", mr: 2 }}
            />
            <Typography sx={{ color: "#000", maxWidth: "90%" }}>
              +234 814 626 6425
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: { xs: 3, md: 0 } }}>
          {/* Social Icons */}
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            sx={{ mb: 2 }}
          >
            <IconButton
              component={Link}
              href="https://www.linkedin.com/company/tuberway"
              target="_blank"
              rel="noopener"
              sx={{ color: "#000" }}
            >
              <LinkedIn />
            </IconButton>

            {/* <IconButton
              component={Link}
              href="https://www.instagram.com/tuberway"
              target="_blank"
              rel="noopener"
              sx={{ color: "#000" }}
            >
              <Instagram />
            </IconButton> */}

            <IconButton
              component={Link}
              href="https://www.tiktok.com/@tuberway"
              target="_blank"
              rel="noopener"
              sx={{ color: "#000" }}
            >
              <TikTokIcon />
            </IconButton>

            <IconButton
              component={Link}
              href="https://x.com/tuberway"
              target="_blank"
              rel="noopener"
              sx={{ color: "#000" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                width="20"
                viewBox="0 0 1200 1227"
                fill="currentColor"
              >
                <path d="M714.163 519.284L1160.89 0H1049.16L667.137 442.632L362.328 0H0L468.492 681.821L0 1226.37H111.733L515.671 761.972L837.672 1226.37H1200L714.137 519.284H714.163ZM572.791 701.252L521.26 628.059L152.049 79.7025H310.477L597.872 496.916L649.403 570.109L1049.21 1153.67H890.781L572.791 701.278V701.252Z" />
              </svg>
            </IconButton>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactInquiry;
